export const floorToNearest = (amount: number, precision: number) => {
  return Math.floor(amount / precision) * precision;
};
export const ceilToNearest = (amount: number, precision: number) => {
  return Math.ceil(amount / precision) * precision;
};
